/*
 * Facebook Pixel docs can be found here:
 * https://developers.facebook.com/docs/facebook-pixel
 * https://developers.facebook.com/docs/facebook-pixel/events-advanced-use-cases/v2.9
 */

import vars from '../../common/vars';

export default function initFbTrack() {
  /* eslint-disable */

  // Facebook Pixel Code
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  // disablePushState = true is not recommended, disables logging on history.pushstate event
  // page views are instead logged by history.listen in src/client/index.js
  fbq.disablePushState = true;

  fbq('init', vars.get('FB_PIXEL_ID').toString());
  fbq('track', 'PageView'); // can only be called once, then only fires on pushstate event

  /* eslint-enable */
}
